<template>
    <Typography
        :class="$style.rating"
        type="label"
        size="s"
        :responsive="false"
    >
        <meter
            :class="$style.average_rating"
            min="0"
            max="5"
            :style="{
                '--rating': props.rating.value,
            }"
            :value="props.rating.count"
        />
        <span :class="$style.invisible"> {{ '★★★★★★★' }} </span>
        <span
            v-if="props.showLabel"
            :class="$style.rating_text"
        >
            {{ props.rating.value }}
        </span>
        <span
            v-if="props.showLabel"
            :class="$style.votes"
            >{{ '\u00A0/\u00A0' + $tr('stars.votes', { count: formatValue(props.rating.count) }, props.rating.count) }}
        </span>
    </Typography>
</template>
<script lang="ts" setup>
import { Rating } from '@/types'
import { formatValue } from '@/utils/numbers'

import Typography from './Typography.vue'

const props = withDefaults(defineProps<{ rating: Rating; showLabel?: boolean }>(), {
    showLabel: true,
})
</script>
<style module>
.rating {
    padding-top: 1px;
    display: inline-flex;
    gap: 4px;
}

.average_rating {
    position: relative;
    appearance: none;
    color: transparent;
    width: auto;
    display: inline-block;
    vertical-align: baseline;
}

.average_rating::before {
    --percent: calc(var(--rating) / 5 * 100%);
    content: '★★★★★';
    position: absolute;
    top: -5px;
    left: 0;
    color: rgba(0, 0, 0, 0.2);
    background: linear-gradient(90deg, #ffc850 var(--percent), var(--carbon-500) var(--percent));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 20px;
    line-height: 20px;
}

.rating_text {
    font-weight: var(--font-weight-accent);
}

.invisible {
    opacity: 0;
}

.votes {
    color: var(--white-60);
}
</style>
